import { Button, IconButton } from '@mui/material';
import { SchoolPropertyCategory } from '@schooly/api';
import { CheckIcon, CrossIcon, Loading, Spin } from '@schooly/style';
import React, { FC, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form-lts';
import { FormattedMessage } from 'react-intl';

import {
  ModalFooter,
  ModalLarge,
} from '../../../../../components/uikit-components/Modal/Modal.styled';
import { ModalHeader } from '../../../../../components/uikit-components/Modal/ModalHeader';
import { SchoolTuneStatus, SchoolTuneStatusesForm } from './scheme';
import { SchoolTuneStatusesModalStaffPanel } from './SchoolTuneStatusesModalStaffPanel';
import { SchoolTuneStatusesModalStudentsPanel } from './SchoolTuneStatusesModalStudentsPanel';
import { getCategoriesByUserType } from './utils';

type SchoolTuneStatusesModalContentProps = {
  studentStatuses: SchoolTuneStatus[];
  staffStatuses: SchoolTuneStatus[];
  isLoading: boolean;
  isSaving: boolean;
  onSubmit: (v: SchoolTuneStatusesForm) => void;
  onClose: () => void;
  title: string;
  categories: SchoolPropertyCategory[];
};

export const SchoolTuneStatusesModalContent: FC<SchoolTuneStatusesModalContentProps> = ({
  staffStatuses,
  studentStatuses,
  onClose,
  onSubmit,
  title,
  isSaving,
  isLoading,
  categories,
}) => {
  const form = useForm<SchoolTuneStatusesForm>({
    defaultValues: {
      students: studentStatuses,
      staff: staffStatuses,
    },
  });

  const { student: studentCategories, staff: staffCategories } = useMemo(
    () => getCategoriesByUserType(categories),
    [categories],
  );

  return (
    <ModalLarge open onClose={onClose}>
      {isLoading ? (
        <Loading />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <ModalHeader title={title}>
              {!isSaving && (
                <IconButton onClick={onClose}>
                  <CrossIcon />
                </IconButton>
              )}
            </ModalHeader>

            <SchoolTuneStatusesModalStudentsPanel categories={studentCategories} />
            <SchoolTuneStatusesModalStaffPanel categories={staffCategories} />

            <ModalFooter sx={{ justifyContent: 'space-between' }}>
              <Button variant="outlined" disabled={isSaving} onClick={onClose}>
                <FormattedMessage id="action-Cancel" />
              </Button>
              <Button
                type="submit"
                disabled={isSaving}
                endIcon={isSaving ? <Spin /> : <CheckIcon />}
              >
                <FormattedMessage id="action-Save" />
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      )}
    </ModalLarge>
  );
};
